module.exports = __webpack_public_path__ + "static/media/happ_loading.fed8dbd8.png";